import React from 'react';
import { usePartner } from '../../contexts/PartnerContext';
export const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg';
export const ZAIN_LOGO = 'https://cdn.magicpatterns.com/uploads/v6desCRNT7CwM3FSbyjh7P/ZainBlackLogo.svg';
export function VexuMark({
  size = 40
}: {
  size?: number;
}) {
  return <img src={VEXU_LOGO} alt="" aria-hidden="true" style={{
    width: size,
    height: size
  }} className="object-contain" data-id="element-444" data-mp="m77vd377rsfq" />;
}
interface VexuLockupProps {
  size?: number;
  wordmarkSize?: number;
  className?: string;
}
export function VexuLockup({
  size = 34,
  wordmarkSize = 22,
  className = ''
}: VexuLockupProps) {
  return <span className={`inline-flex items-center gap-[10px] ${className}`} data-id="element-445" data-mp="3evxotri9fbx">
      <VexuMark size={size} data-id="element-446" data-mp="3bvgznqlpz85j" />
      <span style={{
      fontSize: wordmarkSize
    }} className="font-semibold tracking-[-0.02em] text-slate-900" data-id="element-447" data-mp="3bup4uhzy5egb">
        Vexu.ai
      </span>
    </span>;
}

/** The telecom partner's official logo, used unmodified on the light canvas. */
export function PartnerMark({
  height = 30
}: {
  height?: number;
}) {
  const partner = usePartner();
  return <img src={partner.logo} alt={partner.name} style={{
    height: height * partner.logoScale
  }} className="object-contain" data-id="element-448" data-mp="fvjj9p3ewayi" />;
}
interface PartnershipLockupProps {
  vexuSize?: number;
  vexuWordmarkSize?: number;
  /** Base height of the partner logo before its optical scale is applied. */
  zainHeight?: number;
  gap?: number;
}
export function PartnershipLockup({
  vexuSize = 30,
  vexuWordmarkSize = 19,
  zainHeight = 26,
  gap = 26
}: PartnershipLockupProps) {
  return <div className="inline-flex items-center" style={{
    gap
  }} data-id="element-449" data-mp="16wtetg5s0t1">
      <VexuLockup size={vexuSize} wordmarkSize={vexuWordmarkSize} data-id="element-450" data-mp="140t4ygu901f" />
      <span className="text-slate-300" style={{
      fontSize: vexuWordmarkSize * 0.85
    }} data-id="element-451" data-mp="17lxpcz56oizm">
        ×
      </span>
      <PartnerMark height={zainHeight} data-id="element-452" data-mp="1cndassb9wrij" />
    </div>;
}